import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { userServices } from './userServices';
import { notification } from 'antd';

export const createProfile = createAsyncThunk(
    "user/createProfile",
    async (userData, thunkAPI) => {
        try {
            return await userServices.createProfile(userData);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const loginUser = createAsyncThunk(
    "user/login",
    async (userData, thunkAPI) => {
        try {
            return await userServices.login(userData);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const addImages = createAsyncThunk(
    "user/addImages",
    async (data, thunkAPI) => {
        try {
            return await userServices.addImages(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const deleteImage = createAsyncThunk(
    "user/deleteImage",
    async (data, thunkAPI) => {
        try {
            return await userServices.deleteImage(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const changePassword = createAsyncThunk(
    "user/changePassword",
    async (data, thunkAPI) => {
        try {
            return await userServices.changePassword(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const changePreferences = createAsyncThunk(
    "user/changePreferences",
    async (data, thunkAPI) => {
        try {
            return await userServices.changePreferences(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const changePrivacy = createAsyncThunk(
    "user/changePrivacy",
    async (data, thunkAPI) => {
        try {
            return await userServices.changePrivacy(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const changeVisibility = createAsyncThunk(
    "user/changeVisibility",
    async (data, thunkAPI) => {
        try {
            return await userServices.changeVisibility(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const changeEmailAlerts = createAsyncThunk(
    "user/changeEmailAlerts",
    async (data, thunkAPI) => {
        try {
            return await userServices.changeEmailAlerts(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const deleteProfile = createAsyncThunk(
    "user/deleteProfile",
    async (data, thunkAPI) => {
        try {
            return await userServices.deleteProfile(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const changePersonalProfile = createAsyncThunk(
    "user/changePersonalProfile",
    async (data, thunkAPI) => {
        try {
            return await userServices.changePersonalProfile(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const onlineStatus = createAsyncThunk(
    "user/onlineStatus",
    async (data, thunkAPI) => {
        try {
            return await userServices.onlineStatus(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })
export const recentVisitors = createAsyncThunk(
    "user/recentVisitors",
    async (data, thunkAPI) => {
        try {
            return await userServices.recentVisitors(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })
export const whoVisited = createAsyncThunk(
    "user/whoVisited",
    async (data, thunkAPI) => {
        try {
            return await userServices.whoVisited(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })
export const shortListed = createAsyncThunk(
    "user/shortListed",
    async (data, thunkAPI) => {
        try {
            return await userServices.shortListed(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const blocked = createAsyncThunk(
    "user/blocked",
    async (data, thunkAPI) => {
        try {
            return await userServices.blocked(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })
export const addLikes = createAsyncThunk(
    "user/addLikes",
    async (data, thunkAPI) => {
        try {
            return await userServices.addLikes(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })
export const addAccepted = createAsyncThunk(
    "user/addAccepted",
    async (data, thunkAPI) => {
        try {
            return await userServices.addAccepted(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })
export const addDeclined = createAsyncThunk(
    "user/addDeclined",
    async (data, thunkAPI) => {
        try {
            return await userServices.addDeclined(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const getMatches = createAsyncThunk(
    "user/getMatches",
    async (data, thunkAPI) => {
        try {
            return await userServices.getMatches(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

export const decreaseContact = createAsyncThunk(
    "user/decreaseContact",
    async (data, thunkAPI) => {
        try {
            return await userServices.decreaseContact(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })
export const removeShortlist = createAsyncThunk(
    "user/removeShortlist",
    async (data, thunkAPI) => {
        try {
            return await userServices.removeShortlist(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })
export const unBlock = createAsyncThunk(
    "user/unBlock",
    async (data, thunkAPI) => {
        try {
            return await userServices.unBlock(data);
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    })

const initialState = {
    user: null,
    token: null,
    loading: false,
    error: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        logoutUser: (state, action) => {
            state.token = null;
            state.loading = false;
            state.error = null;
            window.location.replace('/')
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(createProfile.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(createProfile.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.user;
            state.token = action.payload.token;
            notification.success({ message: "User Registered Successfully!" });
        });
        builder.addCase(createProfile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "User Registration Failed!" });
        });
        builder.addCase(loginUser.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(loginUser.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.user;
            state.token = action.payload.token;
            notification.success({ message: "User Logged In Successfully!" });
            window.location.replace('/');
        });
        builder.addCase(loginUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: action.payload.message });
        });
        builder.addCase(addImages.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addImages.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Images Added Successfully!" });
        });
        builder.addCase(addImages.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Images Addition Failed!" });
        });
        builder.addCase(deleteImage.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(deleteImage.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Image Deleted Successfully!" });
        });
        builder.addCase(deleteImage.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Image Deletion Failed!" });
        });
        builder.addCase(changePassword.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(changePassword.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.user;
            notification.success({ message: "Password Changed Successfully!" });
        }
        );
        builder.addCase(changePassword.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Password Change Failed!" });
        }
        );
        builder.addCase(changePreferences.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(changePreferences.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Preferences Changed Successfully!" });
        }
        );
        builder.addCase(changePreferences.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Preferences Change Failed!" });
        }
        );
        builder.addCase(changeEmailAlerts.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(changeEmailAlerts.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Email Alerts Changed Successfully!" });
        }
        );
        builder.addCase(changeEmailAlerts.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Email Alerts Change Failed!" });
        }
        );
        builder.addCase(changePrivacy.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(changePrivacy.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Privacy Changed Successfully!" });
        }
        );
        builder.addCase(changePrivacy.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Privacy Change Failed!" });
        }
        );
        builder.addCase(changeVisibility.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(changeVisibility.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Visibility Changed Successfully!" });
        }
        );
        builder.addCase(changeVisibility.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Visibility Change Failed!" });
        }
        );
        builder.addCase(changePersonalProfile.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(changePersonalProfile.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Profile Changed Successfully!" });
        }
        );
        builder.addCase(changePersonalProfile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Profile Change Failed!" });
        }
        );
        builder.addCase(deleteProfile.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(deleteProfile.fulfilled, (state, action) => {
            state.user = null;
            state.token = null;
            state.loading = false;
            state.error = null;
            notification.success({ message: "Profile Deleted Successfully!" });
            window.location.replace('/');
        }
        );
        builder.addCase(deleteProfile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            notification.error({ message: "Profile Deletion Failed!" });
        }
        );
        builder.addCase(onlineStatus.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(onlineStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
        }
        );
        builder.addCase(onlineStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(recentVisitors.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(recentVisitors.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
        }
        );
        builder.addCase(recentVisitors.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(whoVisited.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(whoVisited.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
        }
        );
        builder.addCase(whoVisited.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(shortListed.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(shortListed.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Shortlisted Successfully!" });
        }
        );
        builder.addCase(shortListed.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(blocked.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(blocked.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Blocked Successfully!" });
        }
        );
        builder.addCase(blocked.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(addLikes.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(addLikes.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Liked Successfully!" });
        }
        );
        builder.addCase(addLikes.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(addAccepted.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(addAccepted.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Accepted Successfully!" });
        }
        );
        builder.addCase(addAccepted.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(addDeclined.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(addDeclined.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Declined Successfully!" });
        }
        );
        builder.addCase(addDeclined.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(decreaseContact.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(decreaseContact.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
        }
        );
        builder.addCase(decreaseContact.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(removeShortlist.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(removeShortlist.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Shortlist Removed Successfully!" });
        }
        );
        builder.addCase(removeShortlist.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
        builder.addCase(unBlock.pending, (state, action) => {
            state.loading = true;
        }
        );
        builder.addCase(unBlock.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.updatedUser;
            notification.success({ message: "Unblocked Successfully!" });
        }
        );
        builder.addCase(unBlock.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
    }
})

export const { logoutUser, setUser } = userSlice.actions;

export default userSlice.reducer;
